import 'intersection-observer' // pollyfil for intersection-observer
import React, { useState } from 'react'
import { InView } from 'react-intersection-observer'

import './App.scss'
import { Navbar, NavigationDots, SocialMedia } from './components'
import { CONTAINER_TITLE } from './constants/enum'
import * as containers from './container'

const App = () => {
  /* Return active container id (container shows in viewport) */
  const [activeContainer, setActiveContainer] = useState(null)
  const handleInView = (status, entry) =>
    status && setActiveContainer(entry.target.id)

  /* dynamically render containers */
  const containerList = CONTAINER_TITLE.map(title => {
    const Container = containers[title]

    return (
      <InView
        fallbackInView
        threshold={0.5}
        key={title}
        onChange={handleInView}
        id={title}>
        <Container />
      </InView>
    )
  })

  return (
    <div className="app">
      <Navbar />

      {containerList}

      <SocialMedia />
      <NavigationDots activeContainer={activeContainer} />
    </div>
  )
}

export default App
